import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  generateVideoThumbnails,
  importFileandPreview,
} from "@rajesh896/video-thumbnails-generator";
import Carousel from "react-elastic-carousel";
import { Loader } from "../Loader";
import classes from "./VideoTumbnail.module.css";
import { base64ToImage } from "../../config/apiUrl";

const VideoTumbnail = ({ video, setThumbnailPicture, thumbnailPicture }) => {
  const [videoUrl, setVideoUrl] = useState("");
  const [videoThumb, setVideoThumb] = useState("");
  const [thumbnails, setThumbnails] = useState([]);
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2, pagination: false },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 4, itemsToScroll: 1 },
    { width: 1450, itemsToShow: 4 },
    { width: 1750, itemsToShow: 4 },
  ];

  const refs = useRef({
    video: null,
    loader: null,
    numberInput: null,
    thumbButton: null,
  });

  useEffect(() => {
    if (video) {
      importFileandPreview(video).then((res) => {
        setVideoUrl(res);
      });
      setVideoThumb("");
      setThumbnails([]);
      if (refs.current.video) {
        refs.current.video.style.transform = "scale(1)";
      }

      if (refs.current.numberInput) {
        refs.current.numberInput.style.display = "block";
      }
      if (refs.current.thumbButton) {
        refs.current.thumbButton.style.display = "block";
      }
      if (refs.current.loader) {
        refs.current.loader.style.display = "block";
      }

      generateVideoThumbnails(video, 5).then(async (thumbs) => {
        setThumbnails(thumbs);
        if (refs.current.loader) {
          refs.current.loader.style.display = "none";
        }
        var canvas = document.getElementById("canvas");
        let videoTag = document.getElementById("video");
        canvas.getContext("2d").drawImage(videoTag, 0, 0, 250, 400);

        let imageBuffer = canvas.toDataURL();
        await base64ToImage(imageBuffer, setThumbnailPicture);
      });
    }
  }, [video]);

  async function captureThumb(item) {
    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");

    var image = new Image();
    image.onload = function () {
      ctx.drawImage(image, 0, 0, 250, 400);
    };
    image.src = item;
    setThumbnailPicture(null);
    base64ToImage(item, setThumbnailPicture);

    // const clr = setTimeout(() => {
    //   captureThumb(item);
    // }, 250);
    // clearTimeout(clr);
  }


  return (
    <>
      <style>
        {`
.rec-item-wrapper{
  // height: 130px;
  // width: 130px;
  // padding: 10PX;
}
.carousel_video {
  border: 1px solid #494646;
  border-radius: 25px;
}
.carousel_video img{
  object-fit: cover;
}

`}
      </style>
      <Container>
        <Row>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className={classes.video_and_thumbnail}>
              <Row
                style={{
                  width: "100%",
                }}
              >
                <Col
                  md={6}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                

                  <video
                    poster={videoThumb}
                    style={{
                      maxWidth: 600,
                      maxHeight: 400,
                      transform: "scale(0)",
                      transition: "all 0.3s",
                    }}
                    controls
                    id="video"
                    ref={(el) => (refs.current.video = el)}
                    src={videoUrl}
                  >
                    <source src={videoUrl} type={video?.type} />
                    Your browser does not support the video tag.
                  </video>
                </Col>
                <Col
                  md={6}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <canvas width={"250"} height={"400"} id="canvas"></canvas>
                </Col>
              </Row>
            </div>
            <div
              style={{ marginTop: 25, display: "none" }}
              id="buttonWrapper"
              ref={(el) => (refs.current.thumbButton = el)}
            ></div>
          </div>
          <div
            id="loader"
            style={{ display: "none", textAlign: "center" }}
            ref={(el) => (refs.current.loader = el)}
          >
            <Loader
            // className={"mvh-100"}
            />
          </div>

          <div
            id="thumbnails"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              alignItems: "center",
              transition: "all 0.3s",
            }}
          >
            <Carousel
              breakPoints={breakPoints}
              className="carousel_video"
              itemsToShow={4}
              itemPadding={[5, 5]}
              showArrows={false}
              pagination={false}
            >
              {thumbnails.map((item) => {
                return (
                  <img
                    id="thumbnail_b"
                    draggable={false}
                    src={item}
                    style={{ width: 200, margin: 10, cursor: "pointer" }}
                    alt=""
                    onClick={() => {
                      captureThumb(item);
                      // setVideoThumb(item);
                      //   window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  />
                );
              })}
            </Carousel>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default VideoTumbnail;
